import { Component, Input, OnInit } from '@angular/core';
import { OidcAuthService } from 'ngx-mat-esign360/lib/core/services/oidc-auth.service';

@Component({
  selector: 'lib-mgmt-main-menu',
  templateUrl: './mgmt-main-menu.component.html',
  styleUrls: ['./mgmt-main-menu.component.scss'],
})
export class MgmtMainMenuComponent implements OnInit {
  @Input() color = 'primary';

  constructor(public authService: OidcAuthService) {}

  ngOnInit(): void {}

  onLogout() {
    this.authService.logout();
  }
}
